import { render, staticRenderFns } from "./PaymentsCheckboxField.vue?vue&type=template&id=7c2a663a&"
import script from "./PaymentsCheckboxField.vue?vue&type=script&lang=js&"
export * from "./PaymentsCheckboxField.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports